(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* 16.10 (D8, runda 3): kraj/waluta i jezyk w naglowku (localization-form.js zamyka panel tylko przez focusout).
     - klik/dotkniecie poza panelem zamyka go (takze gdy fokus byl na <body>), Esc zamyka z dowolnego miejsca i oddaje fokus przyciskowi;
     - po zamknieciu tym samym przyciskiem (toggle) sprzatamy stan formularza (hidePanel), zeby naglowek znowu mogl sie chowac;
     - otwarcie panelu zamyka otwarte podmenu (mega-menu), zeby sie nie nakladaly. Bez nasluchu na najechanie: panel nie zamyka sie,
       gdy wskaznik przechodzi z przycisku do panelu. */
  (function () {
    if (window.__laleLocBound) return;
    window.__laleLocBound = true;

    function expandedForms() {
      return Array.prototype.filter.call(document.querySelectorAll('.lale-loc localization-form'), function (form) {
        var button = form.querySelector('button.localization-form__select');
        return button && button.getAttribute('aria-expanded') === 'true';
      });
    }

    function closeForm(form, refocus) {
      if (typeof form.hidePanel === 'function') form.hidePanel();
      if (refocus) {
        var button = form.querySelector('button.localization-form__select');
        if (button) button.focus();
      }
    }

    document.addEventListener(
      'pointerdown',
      function (event) {
        expandedForms().forEach(function (form) {
          if (!form.contains(event.target)) closeForm(form, false);
        });
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      expandedForms().forEach(function (form) {
        closeForm(form, true);
      });
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      var button = target && target.closest ? target.closest('.lale-loc button.localization-form__select') : null;
      if (!button) return;
      var form = button.closest('localization-form');
      if (button.getAttribute('aria-expanded') === 'true') {
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (details) {
          details.removeAttribute('open');
          var summary = details.querySelector('summary');
          if (summary) summary.setAttribute('aria-expanded', 'false');
        });
      } else if (form) {
        closeForm(form, false);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lale-hp-hero"] && !Shopify.designMode) return;
  try {
    
function setupLaleHeroMotion(scope) {
  scope.querySelectorAll('.lale-hero-modern').forEach(function(hero) {
    var video = hero.querySelector('video');
    var button = hero.querySelector('.lale-hero-modern__motion');
    if (!video || !button || button.dataset.bound) return;
    button.dataset.bound = 'true';
    function sync() {
      button.hidden = video.readyState === 0;
      button.dataset.paused = String(video.paused);
      button.setAttribute('aria-label', video.paused ? button.dataset.play : button.dataset.pause);
    }
    button.addEventListener('click', function() {
      if (video.paused) { var playing = video.play(); if (playing && playing.catch) playing.catch(sync); }
      else video.pause();
    });
    video.addEventListener('loadeddata', sync);
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    sync();
  });
}
setupLaleHeroMotion(document);
document.addEventListener('shopify:section:load', function(event) { setupLaleHeroMotion(event.target); });

  } catch(e) { console.error(e); }
})();
})();
